import React, { useCallback } from 'react'
import { searchServiceCtx } from '../../store/search/search.service.constants'
import emptyMarker from '../genericComponents/assets/empty-marker.svg'
import StatusMessage from '../genericComponents/StatusMessage'
import { useTemporaryVisible } from '../genericComponents/useTemporaryVisible'
import { useT } from '../i18n/T'
import SVGIcon from '../svg/SVGIcon'

import { isNumber } from '../../utils/number'
import copyTextToClipboard from '../utils/Clipboard'
import s from './AddressCoordinates.less'

const isEligibleForXY = address => {
  return [
    searchServiceCtx.geocodeLevel.addressPoint,
    searchServiceCtx.geocodeLevel.addressRange,
    searchServiceCtx.geocodeLevel.namedPlace,
    searchServiceCtx.geocodeLevel.landmark,
    searchServiceCtx.geocodeLevel.way,
    searchServiceCtx.geocodeLevel.unnamed_road
  ].includes(address.geocode_level)
}

const AddressCoordinates = ({ address }) => {
  const { coordinates = {} } = address
  const { lat, lng } = coordinates
  const areLatLngValid = isNumber(lat) && isNumber(lng)
  const [visible, setVisible] = useTemporaryVisible()
  const copiedText = useT('share.coordinates.ok')

  const onClick = useCallback(() => {
    copyTextToClipboard(`${lat.toFixed(5)},${lng.toFixed(5)}`)
      .then(() => {
        setVisible(true)
      })
      .catch(err => {
        console.error('AddressCoordinates clipboard error', err)
      })
  }, [lat, lng])

  if (!areLatLngValid || !isEligibleForXY(address)) return <></>

  return (
    <>
      <div className={s.coordinates} onClick={onClick}>
        <SVGIcon url={emptyMarker} className={s.coordinatesIcon} />
        {`${lat.toFixed(5)}, ${lng.toFixed(5)}`}
      </div>
      <StatusMessage message={copiedText} visible={visible} className={s.shareMessage} />
    </>
  )
}

export default AddressCoordinates
